"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPhoneDigitsOnly = getPhoneDigitsOnly;
exports.phoneIsValidFormat = phoneIsValidFormat;
exports.formatPhone = formatPhone;

var _googleLibphonenumber = require("google-libphonenumber");

function getPhoneDigitsOnly(number) {
  if (typeof number === 'number') number = '' + number;
  if (typeof number !== 'string') return null;
  var numberOnly = number.replace(/[\D]/g, '');
  var numberLength = numberOnly.length;
  return numberLength > 10 ? numberOnly.substring(numberLength - 10) : numberOnly;
}

function phoneIsValidFormat(number) {
  return /^([+]?1)?((\(\d{3}\)[ ]?(\d{3}-\d{4}|\d{7}))|(\d{3}(-\d{3}-\d{4}|-?\d{7})))$/.test(number);
}

function formatPhone(number) {
  try {
    var DEFAULT_REGION = 'US';
    if (typeof number === 'number') number = '' + number;

    if (number) {
      var phoneUtil = _googleLibphonenumber.PhoneNumberUtil.getInstance();

      var phoneParsed = phoneUtil.parseAndKeepRawInput(number, DEFAULT_REGION);
      return phoneUtil.format(phoneParsed, _googleLibphonenumber.PhoneNumberFormat.NATIONAL);
    }

    return '';
  } catch (_unused) {
    // If the phone number is invalid just return the original number
    console.log('Invalid phone passed: ' + number);
    return number;
  }
}